<script>
export default {
  name: "DefaultRouterLink",
  props: {
    route: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<template>
  <router-link :class="[disabled ? 'text-grays-500 pointer-events-none' : 'text-primary-300 cursor-pointer']"
               :to="route"
               class=" underline font-bold hover:text-primary-800 focus:text-primary-900 active:text-primary-900"
  >
    <slot/>
  </router-link>
</template>

<style scoped>

</style>